<template>
  <div>
    <page-content-toolbar
        projectName=""
        :title="(invoice && invoice.accountName) && $t('accountsAndBilling.billing')+' '+invoice.accountName"
    >
    </page-content-toolbar>

    <v-card
      :loading="loading"
      class="mx-auto"
    >
      <template slot="progress">
        <v-progress-linear
          color="blue darken-4"
          height="2"
          indeterminate
        ></v-progress-linear>
      </template>

      <v-card-title>{{ $t('accountsAndBilling.period') }}</v-card-title>

      <v-card-text>
        <v-row cols="6">
          <v-col
            cols="2"
          >
            <v-menu
              ref="menu"
              v-model="menu"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="period"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="period"
                type="month"
                no-title
                scrollable
                :allowed-dates="allowedMonths"
              >
                
              </v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="2">
            <v-text-field
              :label="$t('accountsAndBilling.amount')"
              suffix="€"
              v-model="invoice.amount"
              readonly
            />
            
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-title>{{ $t('accountsAndBilling.billingPlan') }}</v-card-title>

      <v-card-text>
        {{ invoice.billingPlan }}
      </v-card-text>

      <v-card-title>{{ $t('accountsAndBilling.consumptions') }}</v-card-title>

      <v-card-text>
        <v-row cols="6">
          <v-col cols="6">
            <v-data-table
              :loading="loading"
              :headers="headers"
              :items="invoice.lines"
              hide-default-footer
              class="elevation-1"
            ></v-data-table>
          </v-col>
        </v-row>
      </v-card-text>

    </v-card>

  </div>
</template>

<script>
import PageContentToolbar from '@/components/layout/PageContentToolbar';

import invoiceService from '@/services/invoices.js';
import userRightMixin from '@/mixins/user-right-mixin.js';

export default {
  name: 'Billing',

  components: { PageContentToolbar, },

  mixins: [ userRightMixin ],

  data () {
    return {
      loading: true,
      invoice: {
        id: '',
        accountName: '',
        period: '',
        billingPlan: '',
        billingFormula: '',
        lines: [
          {
            description: '',
            quantity: ''
          },
        ]
      },
      period: '',
      currentPeriod: '1990-02',
      isSaving: false,
      menu: false,
      modal: false,
    };
  },

  methods: {
    findInvoice(accountId, period) {
      this.loading = true;
      invoiceService.findInvoice(accountId, period)
        .then((res) => {
          this.invoice = res.data;
        })
        .catch(err => {
          if(err.response.status === 404) {
            this.invoice = Object.assign(this.invoice, {lines: []});
            this.$emit('raison-event', { type: 'error', messages: [this.$t('accountsAndBilling.noBilling', {'period': period})] });
          }
          else {
            this.$emit('raison-event', { type: 'error', messages: [err] });
          }
        })
        .finally(() => {
          this.loading = false;
        })
    },

    allowedMonths: val => parseInt(val.split('-').join(''), 10)<=parseInt(new Date().toISOString().substr(0, 7).split('-').join(''), 10),
  },

  watch: {
    period (period) {
      this.invoice.invoiceLines = Object.assign([]);
      this.invoice.amount = '';
      this.invoice.billingPlan = '';
      this.findInvoice(this.accountId, period)
    }
  },

  computed: {
    headers () {
      return [
        { text: this.$i18n.t('project.projectName'), value: 'description', align: 'start', },
        { text: this.$i18n.t('accountsAndBilling.numberOfRequests'), value: 'quantity' },
      ];
    },
  },

  created () {
    this.loading = true;
    this.accountId = this.$route.params.accountId;
    this.currentPeriod = new Date().toISOString().substr(0, 7);
    this.period = this.$route.params.period || this.currentPeriod;
  },

};
</script>

<style>
</style>
